import * as bootstrap from "bootstrap";
window.htmx = require("htmx.org");

export function createToast(level, title, body) {
  var toastContainer = document.getElementById("toastContainer");

  var toastElement = document.createElement("div");
  toastElement.className = "toast";
  toastElement.setAttribute("role", "alert");
  toastElement.setAttribute("aria-live", "assertive");
  toastElement.setAttribute("aria-atomic", "true");
  toastElement.setAttribute("data-bs-autohide", "true");
  toastElement.setAttribute("data-bs-delay", "3000");

  toastElement.innerHTML = `
          <div class="toast-header bg-${level}">
            <strong class="me-auto">${title}</strong>
            <small>Just now</small>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
          <div class="toast-body">
          ${body}
          </div>
        `;

  toastContainer.appendChild(toastElement);

  var toast = new bootstrap.Toast(toastElement);
  toast.show();
}

htmx.on("showMessage", (e) => {
  createToast(e.detail.level, e.detail.title, e.detail.body);
});
